import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  PaymentElement,
  LinkAuthenticationElement,
} from "@stripe/react-stripe-js";
import axios from "axios";
import {
  useStripe,
  useElements,
  ExpressCheckoutElement,
} from "@stripe/react-stripe-js";
import App from "../App";

const stripePromise = loadStripe(
  "pk_test_51PNdpLKbVdeMCI70nqEYOGMSPnlQrgYIubpXI5EKue0gxxSih3QCkEVzZS1nK5d1zFwoQoPNIWSFDkniA0ZNjPVN00vtfCXJ9g"
);

export default function Subscribe() {
  const [clientSecret, setClientSecret] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    // Fetch the client secret from the server using axios
    axios.defaults.withCredentials = true;

    const createSubscription = async () => {
      try {
        const response = await axios.post(`${API_URL}/create-subscription`, {
          priceId: "price_1PccuCKbVdeMCI70p6NSwn3z",
        });

        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.error("Error creating subscription:", error);
      }
    };

    createSubscription();
  }, []);

  const options = {
    clientSecret,
  };

  return clientSecret ? (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm />
    </Elements>
  ) : (
    <div>PROVA...</div>
  );
}

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `${window.location.origin}/completion`,
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occured.");
    }

    setIsLoading(false);
  };

  return (
    <div className="w-full flex flex-col items-center justify-center min-h-full ">
      <form
        id="payment-form"
        onSubmit={handleSubmit}
        className="p-10 w-full max-w-xl min-h-full bg-white shadow-lg rounded-lg"
      >
        <ExpressCheckoutElement />
        <PaymentElement id="payment-element" />
        <button
          disabled={isLoading || !stripe || !elements}
          id="submit"
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors duration-300"
        >
          <span id="button-text">
            {isLoading ? (
              <div className="spinner" id="spinner"></div>
            ) : (
              "Pay now"
            )}
          </span>
        </button>
        {message && (
          <div id="payment-message" className="mt-4 text-red-500">
            {message}
          </div>
        )}
      </form>
    </div>
  );
};
